<div class="filegrid">
  <div class="filegrid__dropzone filegrid__dropzone--half">
    <swb-dropzone (fileUploaded)="uploaded($event)" *ngIf="field.upload" [imgOnly]="field.imgOnly" [mimeType]="field.mimeType"></swb-dropzone>
    <a class="cta cta--yellow filegrid__browse" (click)="browse()" *ngIf="field.upload">
      <span class="ico-doc"></span> &nbsp;Vybrat</a>
    <a class="cta cta--yellow cta--ico-left filegrid__browse" *ngIf="!field.upload" [routerLink]="{ outlets: { 'browse': ['entities', field.apiUrl, false] } }">
      <span class="ico-plus"></span> Přidat</a>
    <a class="cta cta--green cta--ico-left filegrid__browse" *ngIf="!field.upload && field.canCreate" [routerLink]="{ outlets: { 'modal-form': [field.apiUrl] } }">
      <span class="ico-plus"></span> Vytvořit</a>
  </div>
  <div>
  </div>
  <div class="filegrid__files filegrid__files--half">
    <div class="filegrid__file__wrap">
      <div class="filegrid__file" [ngStyle]="getFileStyle(field.entity)" *ngIf="field.entity">
        <div class="filegrid__actions">

          <a [routerLink]="{ outlets: { 'modal': ['file', field.entity.id] } }" *ngIf="field.entity.is_image" class="filegrid__actions__action">
            <i class="ico-edit"></i>
          </a>
          <a (click)="remove()" class="filegrid__actions__action filegrid__actions__action--remove">
            <i class="ico-remove"></i>
          </a>
        </div>
        <div class="filegrid__filename" *ngIf="!field.entity.is_image">{{ !field.entity.file_name ?
          getTitle(field.entity)
          : field.entity.file_name
          }}</div>
        <div *ngIf="field.entity.file_fullname" class="filegrid__file__filetype media__list__item__filetype--{{field.entity.extension}}">{{field.entity.extension}}</div>
      </div>
    </div>
  </div>
</div>